/* Branded Best House: the sign-up pop-up (snippets/bb-house-popup.liquid).
 * When it opens: after 2 product pages (4 seconds in), or after the delay set in the theme (seconds the page is
 * actually in front of them) on any other page; at most once every 30 days; never again after a sign-up, or after any
 * form on the site was sent; never over another dialog or an open menu; never while they're typing in a form (it
 * tries again 10 seconds later). Every open re-reads that record first (another tab, or a page restored with Back, may
 * have changed it), and "seen" is written the moment it opens. One question first, "When do you need them?", answered
 * with one tap: "Sooner", the next four months we can meet (the 15th of each, whose approve-by day is still ahead, from
 * window.BBDates), or "Not sure yet". The answer's approve-by day shows before the email is asked. It rides along as
 * Shopify customer tags, written as it's chosen: newsletter, popup, and inhands-<YYYY-MM-15>, inhands-soon or
 * inhands-unsure. Every storage access is wrapped: with storage blocked it never opens on its own. */
(function () {
  'use strict';
  if (window.bbHousePopupReady) return;
  window.bbHousePopupReady = true;
  var dlg = document.querySelector('dialog[data-bb-popup]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var KEY = 'bbh-popup';
  var DAYS = 30;
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return null; } }
  function save(rec) { try { localStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) { /* blocked */ } }
  function patch(p) { var r = load(); if (!r) return; Object.keys(p).forEach(function (k) { r[k] = p[k]; }); save(r); }

  function due() {
    var r = load();
    if (!r || r.done) return false;
    return !(r.seen && Date.now() - r.seen < DAYS * 864e5);
  }
  // someone mid-form, or another dialog or menu open: not now
  function busy() {
    if (document.querySelector('dialog[open]') || document.querySelector('header details[open], header-drawer details[open]')) return true;
    var a = document.activeElement;
    return !!(a && a !== document.body && (a.matches('input, textarea, select') || (a.closest && a.closest('form'))));
  }
  function show() {
    if (dlg.open) return true;
    try { dlg.showModal(); } catch (e) { return false; }
    var h = dlg.querySelector('[data-bb-popup-step]:not([hidden]) .bbpop__h, [data-bb-popup-posted] h2');
    if (h) h.focus(); // the heading takes focus, so no answer looks chosen before they pick one
    return true;
  }
  function close() { if (dlg.open) dlg.close(); }
  dlg.querySelector('[data-bb-popup-close]').addEventListener('click', close);
  // a click on the backdrop closes it; a text selection dragged out of a field doesn't
  var downOnBackdrop = false;
  dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
  dlg.addEventListener('click', function (e) { if (e.target === dlg && downOnBackdrop) close(); downOnBackdrop = false; });

  var rec0 = load() || {};
  // this pop-up's own post comes back with its hash (the form's action is /contact#BBHousePopup) or our pending mark;
  // the footer box's post never opens it
  var ours = location.hash === '#BBHousePopup' || !!rec0.pending;

  var posted = dlg.querySelector('[data-bb-popup-posted]');
  if (posted) {
    patch({ done: true, pending: false });
    if (ours) {
      var withDate = !!rec0.pendingDate;
      posted.querySelector('[data-bb-popup-thanks-date]').hidden = !withDate;
      posted.querySelector('[data-bb-popup-thanks-plain]').hidden = withDate;
      show();
    }
    return;
  }

  var step1 = dlg.querySelector('[data-bb-popup-step="1"]');
  var step2 = dlg.querySelector('[data-bb-popup-step="2"]');
  var tags = dlg.querySelector('[data-bb-popup-tags]');
  var months = dlg.querySelector('[data-bb-popup-months]');
  var h2 = dlg.querySelector('[data-bb-popup-h2]');
  var sub = dlg.querySelector('[data-bb-popup-sub]');
  var back = dlg.querySelector('[data-bb-popup-back]');
  var form = dlg.querySelector('form');
  var submit = form.querySelector('button[type="submit"]');
  var D = window.BBDates;
  var NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var choice = rec0.choice && rec0.choice.kind ? rec0.choice : null; // { kind: 'month' | 'soon' | 'unsure', iso }

  // the coming months we can meet: the 15th of each month whose approve-by day is still ahead, the first four
  function monthChoices(today) {
    var out = [], t = D.parseISO(today);
    for (var i = 1; i <= 14 && out.length < 4; i++) {
      var m = t.getUTCMonth() + i;
      var iso = D.ymd(t.getUTCFullYear() + Math.floor(m / 12), m % 12, 15);
      if (D.canPromise(iso, today)) out.push(iso);
    }
    return out;
  }
  function tagOf(c) {
    if (!c) return '';
    if (c.kind === 'month' && /^\d{4}-\d{2}-15$/.test(c.iso || '')) return 'inhands-' + c.iso;
    return c.kind === 'soon' ? 'inhands-soon' : c.kind === 'unsure' ? 'inhands-unsure' : '';
  }
  // the tags are kept current as they answer (Shopify's bot check can take over the send before our handler runs)
  function writeTags() {
    var list = ['newsletter', 'popup'], t = tagOf(choice);
    if (t) list.push(t);
    if (tags) tags.value = list.join(', ');
  }
  function say(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  // step 2 says what their answer means before it asks for anything
  function fill() {
    if (!choice) return;
    if (choice.kind === 'unsure' || !D) {
      say(h2, 'Plan it with us.');
      say(sub, 'Most pieces are in hand about six weeks after you approve your proof. Leave your email and we\'ll help you pick the day.');
      say(submit, 'Help me plan');
    } else if (choice.kind === 'month' && D.parseISO(choice.iso)) {
      say(h2, 'Approve your proof by ' + D.fmtDay(D.approveByDate(choice.iso)) + '.');
      say(sub, 'That\'s the day for pieces in hand by mid\u2011' + NAMES[D.parseISO(choice.iso).getUTCMonth()] + '.');
      say(submit, 'Send me the date');
    } else if (choice.kind === 'soon') {
      say(h2, 'Let\'s see what\'s possible.');
      say(sub, 'Our earliest date is about ' + D.fmtDay(D.earliestInhand(D.todayISO())) + '. Leave your email and we\'ll tell you what we can do.');
      say(submit, 'Ask our team');
    } else {
      say(h2, 'Plan it with us.');
      say(sub, 'Most pieces are in hand about six weeks after you approve your proof. Leave your email and we\'ll help you pick the day.');
      say(submit, 'Help me plan');
    }
  }
  // the email field is described by the step's heading and line (aria-describedby), so a screen reader hears the
  // approve-by date when focus lands there
  function pick(c) {
    choice = c;
    patch({ choice: c });
    writeTags();
    fill();
    step1.hidden = true;
    step2.hidden = false;
    var email = step2.querySelector('input[type="email"]');
    if (email) email.focus();
  }
  if (months) {
    // without the dates (bb-dates.js failed to load) only "Not sure yet" is offered, never an empty question
    var list = [];
    if (D) {
      var today = D.todayISO();
      list.push({ kind: 'soon', label: 'Sooner' });
      monthChoices(today).forEach(function (iso) { list.push({ kind: 'month', iso: iso, label: NAMES[D.parseISO(iso).getUTCMonth()] }); });
    }
    list.push({ kind: 'unsure', label: 'Not sure yet' });
    list.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = c.label;
      b.addEventListener('click', function () { pick({ kind: c.kind, iso: c.iso || '' }); });
      months.appendChild(b);
    });
  }
  if (back) back.addEventListener('click', function () {
    step2.hidden = true;
    step1.hidden = false;
    var first = months && months.querySelector('button');
    if (first) first.focus();
  });
  function markPending() {
    // "We'll email you your approve-by date" only when they picked a month
    patch({ pending: true, pendingDate: !!(choice && choice.kind === 'month'), done: true, choice: choice });
  }
  writeTags();
  fill();
  if (submit) submit.addEventListener('click', function () { if (form.checkValidity()) { writeTags(); markPending(); } });
  form.addEventListener('submit', function () { writeTags(); markPending(); });

  // any other form sent on the site means they've already reached out: never interrupt them after that
  document.addEventListener('submit', function (e) {
    if (e.target !== form && e.target.matches && e.target.matches('form[action*="/contact"], form[action*="/account"]')) patch({ done: true });
  }, true);

  // Shopify sent our form back (a bad email): open at the email step, everything still wired
  if (dlg.querySelector('.bbpop__error')) {
    if (ours) show();
    return;
  }

  // ---- when to open ----
  var fired = false, left = 0, started = 0, timer = 0;
  function openIfDue() {
    timer = 0;
    if (fired || document.hidden) return;              // the visibility handler tries again when they come back
    if (!due()) { fired = true; return; }
    if (busy()) { left = 10000; arm(); return; }
    if (show()) { fired = true; patch({ seen: Date.now() }); }
  }
  function arm() {
    if (fired || timer || document.hidden) return;
    started = Date.now();
    timer = setTimeout(function () { left = 0; openIfDue(); }, Math.max(0, left));
  }
  document.addEventListener('visibilitychange', function () {
    if (fired) return;
    if (document.hidden) {
      if (timer) { clearTimeout(timer); timer = 0; left = Math.max(0, left - (Date.now() - started)); }
    } else {
      arm();
    }
  });
  // a page restored with Back keeps its timers: the record is re-read before any open, so a send elsewhere still counts
  window.addEventListener('pageshow', function (e) { if (e.persisted && !due()) fired = true; });

  var rec = load();
  if (!rec || !due()) return;
  left = Math.max(10, parseInt(dlg.getAttribute('data-delay'), 10) || 40) * 1000;
  if (dlg.getAttribute('data-product-page') === '1') {
    var pv = (rec.pv || 0) + 1;
    patch({ pv: pv });
    if (pv >= 2) left = 4000;
  }
  arm();
})();
